module.exports = __webpack_public_path__ + "printer-icon.a029eba36bd9acec2214231afac40489.svg";